import { TmrBaseResource } from 'stylewhere/api'

export class Balances extends TmrBaseResource {
  static endpoint = 'api/v1/balances' //edge
}
